import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=19b8edc0&"
import script from "./FileList.vue?vue&type=script&lang=js&"
export * from "./FileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b8edc0')) {
      api.createRecord('19b8edc0', component.options)
    } else {
      api.reload('19b8edc0', component.options)
    }
    module.hot.accept("./FileList.vue?vue&type=template&id=19b8edc0&", function () {
      api.rerender('19b8edc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/FileList.vue"
export default component.exports